<template>
  <div class="treemenuvue">
    <XVcourseTree :nodes="tree.nodes" :isvisible="true" :depth="0" :label="tree.label" :rootLevelVisible="rootvisible">
    </XVcourseTree>
  </div>
</template>
<script>
import { util } from 'pevueglobal'
export default {
  name: 'dotnetCourseTree',
  data: function () {
    return {
      tree: {},
      rootvisible: false,
    }
  },
  created: function () {
    var treemodel = {
      label: '',
      icon: '',
      id: 0,
      nodes: [],
    }
    var treemodelsubsub = {
      label: '',
      icon: '',
    }
    util.getDataApi('allroles/PEapi_GetCourseTree', {}).then((data) => {
      this.tree = JSON.parse(JSON.stringify(treemodel))
      if (data != null) {
        data.ds.data0.forEach((mainlevrow) => {
          const maintree = JSON.parse(JSON.stringify(treemodel))
          maintree.label = mainlevrow.mainleveltext
          maintree.icon = ''
          maintree.id = mainlevrow.tblMainLevelID

          data.ds.data1.forEach((sublevrow) => {
            var treemodelsub = JSON.parse(JSON.stringify(treemodel))
            treemodelsub.label = sublevrow.subleveltext
            treemodelsub.icon = ''
            treemodelsub.id = sublevrow.tblSubLevelID

            if (sublevrow.tblSubLevelID !== null && sublevrow.tblMainLevelID === mainlevrow.tblMainLevelID) {
              maintree.nodes.push(treemodelsub)
            }

            data.ds.data2.forEach((subsublevrow) => {
              if (subsublevrow.tblSubLevelID === sublevrow.tblSubLevelID) {
                var clonesubsub = JSON.parse(JSON.stringify(treemodelsubsub))
                clonesubsub.label = subsublevrow.subsubleveltext
                clonesubsub.icon = 'fa fa-book treeIcon'
                clonesubsub.url = './SPE356_BH_Cursusboomdetail.aspx?sub=3&sId=' + subsublevrow.tblSubSubLevelID
                clonesubsub.id = subsublevrow.tblSubSubLevelID
                if (subsublevrow.tblSubSubLevelID !== null) {
                  treemodelsub.nodes.push(clonesubsub)
                }
              }
            })
          })
          this.tree.nodes.push(maintree)
        })
      }
    })
  },
}
</script>
